import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "packageTable",
  data: function data() {
    return {
      indeterminate: true,
      checkAll: false,
      checkAllGroup: [],
      // 选中的值
      columns: [],
      currShowSearch: false,
      // 是否显示查询区域
      showColumnOperation: false
    };
  },
  props: {
    tableName: {
      // 用于显示当前table 表头的colums,localstring 到本地
      type: String,
      default: 'tableName'
    },
    // 显示查询区域
    showSearchArea: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'small'
    },
    packageTableClass: {
      //packageTable基本样式
      type: Boolean,
      default: true
    },
    packageTableTdPadding: {
      //packageTdPadding 单元格之间padding的样式
      type: Boolean,
      default: false
    },
    showSearchBtn: {
      //是否显示高级搜索
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    headBtnList: {
      //头部操作按钮list
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tableData: {
      //表格数据
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columnsData: {
      //表格列数据
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pageSizeOpts: {
      type: Array,
      default: function _default() {
        return [15, 20, 50, 100, 200, 500, 1000];
      }
    },
    spanMethod: {},
    stripe: {
      //是否显示间隔斑马纹
      type: Boolean,
      default: false
    },
    showRefresh: {
      type: Boolean,
      default: true
    },
    showColumns: {
      type: Boolean,
      default: true
    },
    border: {
      //是否显示纵向边框
      type: Boolean,
      default: false
    },
    showTableHeader: {
      //是否显示header
      type: Boolean,
      default: true
    },
    showFooter: {
      //是否显示footer
      type: Boolean,
      default: true
    },
    height: {
      //表格高度
      type: Number
    },
    loading: {
      //表格loading
      type: Boolean,
      default: false
    },
    tabletotallen: {
      //分页总数
      type: Number,
      default: 0
    },
    tablePageSize: {
      //分页尺寸
      type: Number,
      default: 15
    },
    tablePageIndex: {
      //分页index
      type: Number,
      default: 1
    },
    reduceheight: {
      //默认需要减去的高度
      type: Number,
      default: 90
    },
    rowKey: {}
  },
  components: {},
  computed: {},
  methods: {
    initColums: function initColums() {
      this.columns.splice(0);
      var currTableList = localStorage.getItem(this.tableName);
      var currTable = [];

      if (currTableList) {
        currTable = JSON.parse(currTableList);

        for (var i in this.columnsData) {
          var list = this.columnsData[i];

          if (currTable.indexOf(list.title) > -1) {
            this.checkAllGroup.push(list.title);
            this.columns.push(list);
          }
        }
      } else {
        for (var _i in this.columnsData) {
          var _list = this.columnsData[_i];
          this.checkAllGroup.push(_list.title);
          this.columns.push(_list);
        }
      }
    },
    onVisibleChange: function onVisibleChange(val) {
      if (val) {
        this.initColums();
      } else {
        this.indeterminate = true;
        this.checkAll = false;
        var arr = [];

        for (var i in this.columnsData) {
          var list = this.columnsData[i];

          if (this.checkAllGroup.indexOf(list.title) > -1) {
            arr.push(list);
          }
        }

        this.$set(this, 'columns', arr);
        localStorage.setItem(this.tableName, JSON.stringify(this.checkAllGroup));
        this.checkAllGroup.splice(0);
      }
    },

    /**
     * 全选or 全不选
     */
    handleCheckAll: function handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }

      this.indeterminate = false;

      if (this.checkAll) {
        var arr = [];

        for (var i in this.columnsData) {
          arr.push(this.columnsData[i].title);
        }

        this.$set(this, 'checkAllGroup', arr);
      } else {
        this.checkAllGroup.splice(0);
      }
    },
    checkAllGroupChange: function checkAllGroupChange(data) {
      if (data.length === this.columnsData.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },

    /**
     * 控制culums显示的列数
     */
    showColumsParel: function showColumsParel() {
      this.showColumnOperation = true;
    },

    /**
     * 刷新表格
     */
    refresh: function refresh() {
      this.$emit("refreshBtn");
    },
    pageOnchange: function pageOnchange(index) {
      this.$emit("pageonChange", index);
    },
    pageSizeChange: function pageSizeChange(pageSize) {
      localStorage.setItem('pageSize', pageSize);
      this.$emit("pageSizeChange", pageSize);
    },
    initcurrentPage: function initcurrentPage() {
      //重置当前currentpage
      this.$refs.pageRef.currentPage = 1;
    },

    /**
     * 显示面板btn操作
     */
    showSearchParel: function showSearchParel() {
      this.currShowSearch = !this.currShowSearch;
    },
    //选择改变时触发
    selectChange: function selectChange(selection) {
      this.$emit("getSelect", selection);
    },
    handleLoadData: function handleLoadData(item, callback) {
      this.$emit('handleLoadData', item, callback);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.initColums();

      console.log('showSearch', _this.showSearch);
    });
  }
};